import React from "react";

type ButtonProps = {
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
};

export default function Button({children, onClick, disabled, type = "button"}: ButtonProps) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className="w-full h-[60px] border rounded-full border-white flex items-center justify-center px-[75px] font-neutra font-light text-[22px] text-white text-center leading-6 hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer">
            {children}
        </button>
    );
}
